// extracted by mini-css-extract-plugin
module.exports = {"container":"_1_XNGuRVCCSw7bu1Zp3x_P"};